import React from 'react';

import PropTypes from 'prop-types';

import { useLocale } from '@adsk/alloy-react-locale';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { useCostContext } from './CostProvider';
import { customizedType } from '../helpers/localeHelper';

const SelectedCount = ({ count, type }) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  const { terminologies } = useCostContext();
  const text = T.translate('SELECTED_COUNT', {
    context: count,
    type: customizedType(T, type, terminologies),
  });
  return (
    <div style={{ maxWidth: 180, pointerEvents: 'auto' }}>
      <OverflowTooltip content={text}>{text}</OverflowTooltip>
    </div>
  );
};
SelectedCount.propTypes = {
  count: PropTypes.number,
  type: PropTypes.object,
};

export default SelectedCount;
